import { CARD_DECK_COLORS } from './constants';

interface ErrorMessageProps {
  message?: string;
  onRetry?: () => void;
  buttonText?: string;
}

/**
 * ErrorMessage Component
 * 
 * Displays error message when activity fetching fails.
 * Shows friendly error message with optional retry button.
 */
export default function ErrorMessage({
  message = 'Unable to load activities. Please try again.',
  onRetry,
  buttonText = 'Try Again',
}: ErrorMessageProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-6 p-8 text-center">
      {/* Error icon */}
      <div
        className="w-16 h-16 rounded-full flex items-center justify-center"
        style={{ backgroundColor: 'rgba(239, 68, 68, 0.1)' }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2zm0 25.2c-6.188 0-11.2-5.012-11.2-11.2S9.812 4.8 16 4.8 27.2 9.812 27.2 16 22.188 27.2 16 27.2z"
            fill="#EF4444"
          />
          <path
            d="M16 9.6c-.773 0-1.4.627-1.4 1.4v7c0 .773.627 1.4 1.4 1.4.773 0 1.4-.627 1.4-1.4v-7c0-.773-.627-1.4-1.4-1.4zM16 22.4c-.773 0-1.4.627-1.4 1.4 0 .773.627 1.4 1.4 1.4.773 0 1.4-.627 1.4-1.4 0-.773-.627-1.4-1.4-1.4z"
            fill="#EF4444"
          />
        </svg>
      </div>

      {/* Error heading */}
      <div className="flex flex-col gap-2">
        <h3
          className="font-medium"
          style={{
            fontSize: '20px',
            color: CARD_DECK_COLORS.titleText,
            fontFamily: 'DM Sans, sans-serif',
          }}
        >
          Oops! Something went wrong
        </h3>
        
        {/* Error message */}
        <p
          style={{
            fontSize: '14px',
            color: CARD_DECK_COLORS.descriptionText,
            fontFamily: 'DM Sans, sans-serif',
          }}
        >
          {message}
        </p>
      </div>

      {/* Retry button (optional) */}
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-6 py-3 rounded-lg font-medium transition-opacity hover:opacity-90"
          style={{
            backgroundColor: CARD_DECK_COLORS.buttonBackground,
            color: CARD_DECK_COLORS.buttonText,
            fontSize: '14px',
            fontFamily: 'DM Sans, sans-serif',
          }}
        >
          {buttonText}
        </button>
      )}
    </div>
  );
}
